import { Component, HostListener, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { DialogService } from 'src/app/shared/dialog/confirm-dialog/dialog.service';
import { LogoutString } from 'src/app/shared/enum/logoutString';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  activateGoTop: boolean = true;
  isLoggedIn: any;
  activeAccountInfo: any;
  public logoutEnum = LogoutString;
  constructor(
    private router: Router,
    private dialogService: DialogService,
    private msalService: MsalService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.elementPosition = this.menuElement.nativeElement.offsetTop + 50;
    this.changeDetector.detectChanges();
  }

  @ViewChild('stickyMenu')
  menuElement!: ElementRef;
  sticky: boolean = false;
  elementPosition: any;

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= this.elementPosition) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }
  }

  login() {
    if (this.isLoggedIn) {
      this.router.navigate(['home/resources']);
    } else {
      this.router.navigate(['login']);
    }
  }

  logout(): void {
    this.dialogService.confirmDialog({
      title: this.logoutEnum.logout_dialog_heading,
      module: 'logout',
      message: this.logoutEnum.logout_dialog_body,
      confirmText: this.logoutEnum.logout_dialog_primary_btn,
      cancelText: this.logoutEnum.logout_dialog_secondary_btn
    }).subscribe(res => {
      if (res) {
        localStorage.removeItem("authenticatedUser");
        document.cookie = 'HangFireCookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        let ss = (this.msalService.instance.getActiveAccount())?.homeAccountId;
        let loginhint = (this.msalService.instance.getActiveAccount())?.idTokenClaims?.login_hint;
        const currentAccount = this.msalService.instance.getAccountByHomeId(ss!);
        if (currentAccount != null) {
          this.msalService.instance.logoutRedirect({ account: currentAccount, idTokenHint: loginhint, logoutHint: loginhint });
          localStorage.clear();
        } else {
          this.msalService.instance.logoutRedirect()
        }

      }
    });

  }

  scrollToTop() {
    return window.scrollTo(0, 0);
  }

  scrollToSection(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  navigateTerms() {
    this.router.navigate(['/terms-and-conditions']);
  }

  navigateToDashboard() {
    this.router.navigate(['/home/resources']);
  }

  navigateToHome() {
    this.router.navigate(['/']);
  }
  navigateTo(navLink: any): void {
    let staticAddress = 'https://www.icertis.com/';
    this.dialogService.confirmDialog({
      title: this.logoutEnum.redirect_dialog_heading,
      module: 'resources',
      message: this.logoutEnum.redirect_dialog_body,
      confirmText: this.logoutEnum.redirect_dialog_primary_btn,
      cancelText: this.logoutEnum.redirect_dialog_secondary_btn
    }).subscribe((res: any) => {
      if (res) {
        if (navLink == 'home') {
          window.open(staticAddress, "_blank");
        } else {
          window.open(staticAddress + navLink, "_blank");
        }

      }
    })
  }

}
